var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeactivateAccountIcon = function SvgDeactivateAccountIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-slash",
    "data-name": "Icon awesome-user-slash",
    d: "M14.856,10.737,8.493,5.82A2.993,2.993,0,1,0,4.527,2.752L1.068.08A.376.376,0,0,0,.54.145L.081.736a.373.373,0,0,0,.066.525L13.937,11.918a.376.376,0,0,0,.527-.066l.459-.593a.371.371,0,0,0-.068-.523ZM2.251,9.9v.975A1.125,1.125,0,0,0,3.376,12h8.208L4.862,6.8A3.145,3.145,0,0,0,2.251,9.9Z",
    transform: "translate(-0.002)",
    fill: "#d85e62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeactivateAccountIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "deactivate-account-icon.c4ddf91ead47d3474e0963cc9aa6f902.svg";